"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _stitches = require("../../stitches.config");

var _themeMap = _interopRequireDefault(require("../../themes/themeMap"));

var BrandFamilyImage = (0, _stitches.styled)('img', {
  padding: '25px 60px 0',
  variants: {
    style: {
      asics_perf_jp: {
        padding: '25px 20px 0',
        '@desktop': {
          padding: '25px 130px 0'
        }
      }
    }
  }
});
/**
 * The image collection of brands represented by style.
 */

var BrandFamily = function BrandFamily(_ref) {
  var _themeMap$style, _themeMap$style$image;

  var style = _ref.style;
  var image = (_themeMap$style = _themeMap.default[style]) === null || _themeMap$style === void 0 ? void 0 : (_themeMap$style$image = _themeMap$style.images) === null || _themeMap$style$image === void 0 ? void 0 : _themeMap$style$image.blackBrandFamily;
  return Boolean(image) && /*#__PURE__*/_react.default.createElement(BrandFamilyImage, {
    alt: "ASICS Brand Family",
    src: image,
    style: style
  });
};

BrandFamily.defaultProps = {
  style: ''
};
var _default = BrandFamily;
exports.default = _default;